import { render, staticRenderFns } from "./DeliverySettingsForm.vue?vue&type=template&id=9a405578&"
import script from "./DeliverySettingsForm.vue?vue&type=script&lang=ts&"
export * from "./DeliverySettingsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports